import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  contentChild,
  input,
  model,
  output,
  signal,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-panel',
  templateUrl: './panel.component.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  standalone: false,
})
export class PanelComponent {
  readonly showClose = input(false);
  readonly onClose = output<PanelComponent>();

  readonly showCollapse = input(true);
  /** Two-way: a host may bind [(isCollapsed)]; the collapse icon also flips it. */
  readonly isCollapsed = model(false);

  readonly title = contentChild<TemplateRef<unknown>>('title');
  readonly menu = contentChild<TemplateRef<unknown>>('menu');
  readonly body = contentChild<TemplateRef<unknown>>('body');

  readonly showMenu = signal(false);

  closeClick() {
    this.onClose.emit(this);
  }

  collapseClick() {
    this.isCollapsed.update((collapsed) => !collapsed);
  }

  toggleMenu() {
    this.showMenu.update((shown) => !shown);
  }

  hideMenu() {
    this.showMenu.set(false);
  }
}
